import { PackageSchema } from '../types/package';

export const validatePackageData = (data: any): { isValid: boolean; errors: string[] } => {
  const errors: string[] = [];

  // Helper function for date validation
  const isValidDate = (dateStr: string) => {
    const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/(19|20)\d\d$/;
    return regex.test(dateStr);
  };

  // Required fields validation
  const requiredFields = [
    { key: 'name', label: 'اسم الباقة' },
    { key: 'mainMakkahHotel', label: 'اسم فندق مكة الأساسي' },
    { key: 'mainMakkahStartDate', label: 'تاريخ بداية فندق مكة الأساسي' },
    { key: 'mainMakkahEndDate', label: 'تاريخ نهاية فندق مكة الأساسي' },
    { key: 'packageType', label: 'نوع الباقة' },
    { key: 'camp', label: 'المخيم' }
  ];

  for (const field of requiredFields) {
    if (!data[field.key]) {
      errors.push(`${field.label} مطلوب`);
    }
  }

  // Date validations
  const dateFields = [
    'mainMakkahStartDate',
    'mainMakkahEndDate',
    'shiftingMakkahStartDate',
    'shiftingMakkahEndDate',
    'madinahStartDate',
    'madinahEndDate',
    'mainMakkahContractStartDate',
    'mainMakkahContractEndDate',
    'shiftingMakkahContractStartDate',
    'shiftingMakkahContractEndDate',
    'madinahContractStartDate',
    'madinahContractEndDate'
  ];

  for (const field of dateFields) {
    if (data[field] && !isValidDate(data[field])) {
      errors.push(`صيغة التاريخ يجب أن تكون dd/mm/yyyy في ${field}`);
    }
  }

  // Package type validation
  const validPackageTypes = [
    'luxuary',
    'premium',
    'standard',
    'luxuary shifting',
    'premium shifting',
    'standard shifting'
  ];
  if (data.packageType && !validPackageTypes.includes(data.packageType)) {
    errors.push('نوع الباقة غير صالح');
  }

  // Camp validation
  const validCamps = ['Majar al kabas', 'al measuem'];
  if (data.camp && !validCamps.includes(data.camp)) {
    errors.push('المخيم غير صالح');
  }

  return {
    isValid: errors.length === 0,
    errors
  };
};

export const generatePackageTemplate = (): PackageSchema => {
  return {
    name: 'ithraa al khair 01',
    
    // Main Makkah Hotel
    mainMakkahHotel: 'Voco',
    mainMakkahStartDate: '24/12/2024',
    mainMakkahEndDate: '30/12/2024',
    mainMakkahContractId: 'MKH-2024-001',
    mainMakkahContractStartDate: '20/12/2024',
    mainMakkahContractEndDate: '05/01/2025',
    
    // Shifting Makkah Hotel
    shiftingMakkahHotel: 'al jaber towers',
    shiftingMakkahStartDate: '30/11/2024',
    shiftingMakkahEndDate: '10/12/2024',
    shiftingMakkahContractId: 'SMK-2024-001',
    shiftingMakkahContractStartDate: '28/11/2024',
    shiftingMakkahContractEndDate: '15/12/2024',
    
    // Madinah Hotel
    madinahHotel: 'elaf al taqwa',
    madinahStartDate: '10/12/2024',
    madinahEndDate: '20/12/2024',
    madinahContractId: 'MDN-2024-001',
    madinahContractStartDate: '08/12/2024',
    madinahContractEndDate: '22/12/2024',
    
    packageType: 'luxuary shifting',
    camp: 'Majar al kabas'
  };
};